import { CommonModule } from '@angular/common';
import { Component, ViewChild } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgOtpInputComponent, NgOtpInputModule } from 'ng-otp-input';
import { ToastrService } from 'ngx-toastr';

import { ButtonComponent } from '../../components/button/button.component';
import { FlagPhoneInputComponent, Phone } from '../../components/flag-phone-input/flag-phone-input.component';
import { HeaderComponent } from '../../components/header/header.component';
import { LoadingComponent } from '../../components/loading/loading.component';
import { TitleComponent } from '../../components/title/title.component';
import { Payment } from '../../domain/models/payment';
import { Table } from '../../domain/models/table';
import { TableService } from '../../domain/services/table.service';
import { UserService } from '../../domain/services/user.service';
import { LocalStorageService } from '../../services/local-storage.service';

@Component({
    selector: 'app-authenticate',
    imports: [
        CommonModule,
        FormsModule,
        NgOtpInputModule,
        FlagPhoneInputComponent,
        LoadingComponent,
        HeaderComponent,
        ButtonComponent,
        TitleComponent,
    ],
    templateUrl: './authenticate.component.html',
    styleUrl: './authenticate.component.scss'
})
export class AuthenticateComponent {

  @ViewChild(NgOtpInputComponent, { static: false }) otpInput: NgOtpInputComponent;
  
  uuid: string;
  paymentSelected: Payment;
  timer: number = 60;
  ticking: boolean = false;
  step: number = 1;
  phone: string | undefined;
  country: string;
  name: string | undefined;
  otp: string | undefined;
  canAdvance: boolean = false;
  loading: boolean = false;
  showPaymentMethod: boolean = true;
  last4Phone: string = '';
  dddPhone: string = '';
  tickTimoutId: any
  idi: number | 0;
  tableCartId: number | 0;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private tableService: TableService,
    private userService: UserService,
    private toastr: ToastrService,
    private localStorageService: LocalStorageService,
  ) {
    this.paymentSelected = this.tableService.getPayment();
    this.uuid = String(this.route.snapshot.paramMap.get('uuid'));
    const table = this.tableService.getTable()
    if(!table) {
      this.tableService.loadTable(this.uuid);
    }

    this.showPaymentMethod = this.userService.getOrigin() == 'PAY';

    this.tableService.$openedTable.subscribe(
        (table: Table | null) => {
          if(table) {
            this.idi = table.idi;
            this.tableCartId = table.tableCartId;
            
            // Validate table session
            this.validateTableSession(table);
          }
        } 
    )
  }
  
  handleBack() {
    this.handleHome("")
  }
  
  handlePhoneData(data: Phone){
    this.phone = data.phone;
    this.country = data.country_code;
    if(data.phone?.replace(/\D/g,'').length == data.minPhoneSize) {
      this.canAdvance = true;
    }

    this.last4Phone = this.phone?.slice(-4) ?? '';
    this.dddPhone = this.phone?.slice(0, 2) ?? '';
  }

  handleName() {
    if(this.name?.length) {
      this.canAdvance = true;
    }
  }

  handleNextStep() {
    if(!this.canAdvance) {
      return;
    }

    if(this.step == 1 && this.phone) {
      this.loading = true;
      this.userService.preAuth(this.country, this.phone, this.idi).subscribe({
        next: () => {
          this.loading = false;
          this.nextStep(3);
          this.tickSmsTimer();
        },
        error: (e) => {
          this.loading = false;
          if(e.status == 404) {
            this.nextStep()
          } else {
            this.toastr.error('Por favor, verifique os dados e tente novamente','Ocorreu um erro ao buscar informações')
          }
        },
      })
    } else if(this.step == 2 && this.phone && this.name) {
      this.loading = true;
      this.userService.register(this.country, this.phone, this.name, this.idi,this.tableCartId).subscribe({
        next: () => {
          this.loading = false;
          this.nextStep();
          this.tickSmsTimer();
        },
        error: (e) => {
          this.loading = false;
          this.toastr.error('Por favor, verifique os dados e tente novamente','Ocorreu um erro ao cadastrar')
        },
      })
    } else if(this.step == 3 && this.phone && this.otp) {
      this.loading = true;
      // this.userService.login(this.country, this.phone, this.otp,this.idi,this.tableCartId).subscribe({
      //   next: () => {
      //     this.loading = false;
      //     if(this.userService.getOrigin() == 'PAY') {
      //       this.handlePayment();
      //     } else if(this.userService.getOrigin() == 'MENU') {
      //       this.handleHome("menu");
      //     } else {
      //       this.handleReceipts();
      //     }
      //   },
      //   error: (e): void => {
      //     this.loading = false;
      //     this.toastr.error('Por favor, verifique os dados e tente novamente','Ocorreu um erro ao logar')
      //   }
      // })
    }
  }

  handleHome(type: string = "") {
    this.router.navigate([`${this.uuid}`, { type: type }])
  }

  handleResendConfirmation(){
    if(this.phone){
      this.userService.resendSms(this.country, this.phone).subscribe({
        next: () => {
          this.timer = 60;
          this.tickSmsTimer();
        }
      })
    }
  }

  nextStep(step?: number) {
    if(step) {
      this.step = step
    } else {
      this.step++;
    }
    this.canAdvance = false;
  }

  backStep() {
    if(this.step > 1) {
      this.step--;
    } else {
      this.step = 1;
    }
  }

  tickSmsTimer() {
    if(this.timer > 0 && !this.ticking) {
      this.ticking = true
      this.tickTimoutId = setTimeout(() => {
        this.timer--
        this.ticking = false;
        this.tickSmsTimer()
      }, 1000)
    } else {
      this.ticking = false
      clearTimeout(this.tickTimoutId)
    }
  }

  onOtpChange(data: string) {
    this.otp = data;

    if(this.otp.length == 6) {
      this.canAdvance = true;
    }
  }

  handlePayment() {
    this.loading = true;
    this.router.navigate([`${this.uuid}/details/payments`])
  }

  handleReceipts() {
    this.router.navigate([`${this.uuid}/receipts`])
  }

  validateTableSession(table: Table) {
    const storedTableId = this.localStorageService.getItem<number>('table_id');
    const storedTableCartId = this.localStorageService.getItem<number>('table_cart_id');
    
    // If there are stored IDs and they differ from the current table
    if (storedTableId && storedTableCartId && 
        (storedTableId !== table.tableId || storedTableCartId !== table.tableCartId)) {
      this.tableService.clearSession();
      
      // Show error message
      this.toastr.error('Por favor, acesse a página novamente através do QR Code.', 'Sessão inválida');
      
      // Redirect to home
      this.router.navigate([this.uuid]);
    }
  }
}
